import Swiper from '../../../../../../Swiper/Swiper';
import { SwiperSlide } from 'swiper/react';
import React, { useCallback, useMemo, useRef, useState } from 'react';

export default function HeroCarousel({ superMap, carouselId, styleState = [], carouselItems = [], siteFormat }) {
  const sliderSettings = useMemo(() => {
    const controls = !['chanelhomepageespot-carousel', 'carousel-no-arrows-no-dots'].includes(carouselId);
    const noArrows = ['carousel-no-arrows', 'carousel-no-arrows-no-dots'].includes(carouselId);

    return {
      navigation: noArrows ? false : {},
      autoplay: !isSearchEngine() && {
        delay: 3000,
        control: controls,
        pauseOnMouseEnter: true,
      },
      loop: true,
      pagination: controls ? { clickable: true } : false,
      speed: 300,
    };
  }, [carouselId]);

  const onSlideChange = useCallback(() => {
    loadImagesFromAttribute(carouselId, siteFormat);
  }, [carouselId, siteFormat]);

  return (
    <div role='region' aria-label='hero-carousel' className={`ContentRecommendation ${carouselId} swiper-overlaps`}>
      <div id={carouselId} {...superMap}>
        {styleState.map((thisStyle, i) => (
          <style key={i} dangerouslySetInnerHTML={{ __html: thisStyle }} />
        ))}
        <Swiper onSlideChange={onSlideChange} {...sliderSettings}>
          {carouselItems.map((thisItem, i) => {
            return (
              <SwiperSlide key={i}>
                <div suppressHydrationWarning={true} dangerouslySetInnerHTML={{ __html: thisItem }} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}

function loadImagesFromAttribute(carouselId, siteFormat) {
  setTimeout(() => {
    // Carousel managed by management center, therefore we need to load images from data attributes.
    const _img = document.querySelector(`#${carouselId} .swiper-slide-active img`);
    if (!_img) return;

    let imgUrl = 'data-deskimage';
    let imgClass = 'desktop-img';
    if (siteFormat !== undefined && siteFormat === 'mobile') {
      imgUrl = 'data-mobileimage';
      imgClass = 'mobile-img';
    }
    const _url = _img.getAttribute(imgUrl);
    const src = _img.getAttribute('src');
    const deskmap = _img.getAttribute('data-deskmap');

    if (deskmap !== undefined && deskmap !== null) {
      _img.setAttribute('usemap', deskmap);
    }

    if (typeof src === 'undefined' || src === '' || src === ' ') {
      _img.setAttribute('src', _url);
      _img.style.display = 'block';
      _img.classList.add(imgClass);
    }
  }, 0);
}

function isSearchEngine() {
  if (typeof window != 'undefined') {
    const theUserAgent = navigator.userAgent;
    const userAgentsWeAreLookingFor = [
      'Googlebot',
      'Chrome-Lighthouse',
      'PTST',
      'AdsBot-Google',
      'DuckDuckBot',
      'Slurp',
      'Baiduspider',
      'YandexBot',
      'Facebot',
      'facebookexternalhit',
      'ia_archiver',
      'LinkedInBot',
      'Google Page Speed Insights',
      'Search Console',
      'Sogou web spider',
      'bingbot',
      'Twitterbot',
      'YandexMobileBot',
      'Pingdom.com_bot',
      'SpeedCurve',
    ];
    for (let iUA = 0; iUA < userAgentsWeAreLookingFor.length; iUA++) {
      if (theUserAgent.indexOf(userAgentsWeAreLookingFor[iUA]) > -1) {
        //this is a user agent we want not to autoplay
        return true;
      }
    }
  }
  return false;
}
